import FormsetItem from '@/components/inputs/Formset/FormsetItem'
import Formset from '@/components/inputs/Formset/Formset'
import { get } from 'lodash'

class Item {
  constructor({ fields, headerLabel, items, item }) {
    this.component = FormsetItem
    this.children = fields
    this.props = {
      headerLabel,
      items,
      item
    }
  }
}

export default class {
  constructor({ modelPath, items, blankObject, sectionName = '', required = false }) {
    if (typeof modelPath[0] === 'string') {
      throw Error('First element in modelPath must be "this"')
    }

    this.vue = modelPath.shift()

    this.props = {
      errors: this.getErrorsForPath(modelPath),
      items: get(this.vue, modelPath),
      blankObject: blankObject || {},
      sectionName,
      required
    }

    this.component = Formset
    this.children = items.map((formset_item, i) => {
      return new Item({
        ...formset_item,
        item: get(this.vue, modelPath)[i],
        items: get(this.vue, modelPath)
      })
    })
  }

  getErrorsForPath(path) {
    const errorsPath = path[0] === 'form' ? path.slice(1) : path
    return get(this.vue.errors, errorsPath)
  }
}
